import { DialogName, ActionTypes } from '../constants';
import { CloseOrganizationDialogAction } from '../types';

export default function closeDialog(name: DialogName): CloseOrganizationDialogAction {
  return {
    type: ActionTypes.CLOSE_ORGANIZATION_DIALOG,
    payload: name,
  };
}
